/**
 * Module for functions for Verana store // theme.js
 * Copyright (c) Mikhail Arden // KDM Designs
 *
 */

$(document).ready(function () {
  // Elements global; used across the theme.js file
  var _$ = {
    dev_mode: true,
    // Show more/toggle elements
    toggleTrigger: $(".toggleContent"),
    smallExcerpt: $(".smallExcrept"),
    fullContent: $(".fullContent"),
  };

  // Save existing sort parameters
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  // Add existing sort parameters to current URL
  $(document).on("click", ".collectionSortOptionMobile", function () {
    var value = $(this).attr("data-value");
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  $(document).on("change", ".sort-by", function () {
    var value = $(this).val();
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  $(window).scroll(function () {
    var height = $("#shopify-section-header").height();
    $("#shopify-section-header").addClass("scrollable");
    $(".contentBody").css("padding-top", height + "px");
  });

  var currentWidth = $(window).width();

  if (currentWidth < 800) {
    $(".productImagesMobile").slick({
      infinite: true,
      autoplay: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
    });
  }
  
  function showCartNotification() {
    console.log("showCartNotification called");
    
    // Print debug info about the notification element
    var notification = $(".cartNotifications");
    console.log("Cart notification element exists:", notification.length > 0);
    console.log("Current notification display:", notification.css("display"));
    
    // Directly reveal cart notification with important CSS overrides
    notification.attr("style", "display: block !important; z-index: 9999 !important; opacity: 1 !important; pointer-events: auto !important;");
    notification.addClass("slide-in-top");
    
    // Log after applying styles
    console.log("Applied styles to notification");
    console.log("Now notification display:", notification.css("display"));
    console.log("Is notification visible:", notification.is(":visible"));
    
    // Force clickability on checkout button
    $(".cartNotifications a[href='/checkout']").attr("style", "pointer-events: auto !important; cursor: pointer !important;");
    
    // Get latest cart data
    jQuery.getJSON("/cart.js", function(cart) {
      console.log("Cart data received:", cart);
      $(".cartNotificationCount").text(cart.item_count);
      
      if (cart.items && cart.items.length > 0) {
        var currentCartItem = cart.items[0];
        $(".cartNotificationTitle").text(currentCartItem.title || "Item added to cart");
        
        if (currentCartItem.image) {
          $(".cartNotificationImage").attr("src", currentCartItem.image);
        }
      }
    });
  }

  function formatCurrency(total) {
    var neg = false;
    if (total < 0) {
      neg = true;
      total = Math.abs(total);
    }
    return (neg ? "-£" : "£") + parseFloat(total, 10).toFixed(2);
  }

  function hideCartNotification() {
    $(".cartNotifications").css("display", "none");
    $(".cartNotifications").removeClass("slide-in-top ");
    $(".cartNotificationTitle").text("");
    $(".cartNotificationImage").attr("src", "");
  }

  function mobileFilterDisplay() {
    var top = $("#shopify-section-header").height();
    var windowHeight = $(window).height();
    var filterHeight = parseInt(windowHeight - top);
    $(".filterColumn")
      .addClass("mobileTriggered overflow-scroll")
      .removeClass("hidden")
      .css("top", top + "px")
      .css("height", filterHeight + "px");
  }

  function mobileFilterHidden() {
    var top = 0;
    var windowHeight = $(window).height();
    var filterHeight = parseInt(windowHeight - top);
    $(".filterColumn")
      .removeClass("mobileTriggered overflow-hidden")
      .addClass("hidden")
      .css("top", top + "px");
  }

  function mobileSortDisplay() {
    var top = $("#shopify-section-header").height();
    var windowHeight = $(window).height();
    var filterHeight = parseInt(windowHeight - top);
    $(".collectionSortMobile")
      .addClass("mobileTriggered overflow-scroll")
      .removeClass("hidden")
      .css("top", top + "px")
      .css("height", filterHeight + "px");
  }

  function mobileSortHidden() {
    var top = 0;
    var windowHeight = $(window).height();
    var filterHeight = parseInt(windowHeight - top);
    $(".collectionSortMobile")
      .removeClass("mobileTriggered overflow-hidden")
      .addClass("hidden")
      .css("top", top + "px");
  }


  function updateCartElms(){
    setTimeout(() => {
      jQuery.getJSON("/cart.js", function (cart) {
        $(".cartNotificationCount").text(cart.item_count);
        cartPrice = cart.total_price / 100;
        cartPrice = formatCurrency(cartPrice)
        $('.cart_total').text(cartPrice)

        if (cart.total_price <= 0) {
          $('.cart_empty_message').show()
        } else {
          $('.cart_empty_message').hide()
        }
      });
    }, 500);
  }
  
  $(document).on("click", ".quantity__button,.remove_item", function () {
    // Cart Controls
    event.preventDefault();
    var type = $(this).attr("name");
    var parentElm = $(this).parents(".cart_items_controls");
    var variantID = parentElm.attr("data-variant");
    var quantityInput = parentElm.find(".quantity__input");
    var priceElm = parentElm.parents('.cart-items').find('.price--end')
    var currentPrice = parseInt(priceElm.attr('data-price'))

    if (type == "remove") {
      CartJS.removeItemById(variantID);
      parentElm.parents('.cart-items').remove()// remove elm visually.
      updateCartElms() // end of function

    } else if (type == "minus") {
      var currentValue = parseInt(quantityInput.val());
      var newValue = currentValue - 1; 
      CartJS.updateItemById(variantID, newValue);
      quantityInput.val(newValue)
      quantityInput.text(newValue)

      if (newValue <= 0) {
        CartJS.removeItemById(variantID);
        parentElm.parents('.cart-items').remove()// remove elm visually.
      } else {
        var newValPrice = (currentPrice * newValue) / 100;
        var newPrice = formatCurrency(newValPrice);
        priceElm.text(newPrice)
      }
      updateCartElms() // end of function
    } else if ((type = "plus")) {

      var currentValue = parseInt(quantityInput.val());
      var newValue = parseInt(currentValue + 1); 
      CartJS.updateItemById(variantID, newValue);
      quantityInput.val(newValue)
      quantityInput.text(newValue)
      var newValPrice = (currentPrice * newValue) / 100;
      var newPrice = formatCurrency(newValPrice);
      priceElm.text(newPrice)

      updateCartElms() // end of function
    } else {
      // Additional controls for the future.
      console.log("Cart controls triggered! But this has no actions :)");
    }
  });

  $(document).on("click", ".closeMobileFilter", function () {
    event.preventDefault();
    mobileFilterHidden();
  });

  $(document).on("click", ".Back2Top", function () {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  $(document).on("click", ".sortHeader", function () {
    var state = $(this).attr("data-state");
    if (state == "closed") {
      $(this).attr("data-state", "open");
      $('.mobileFilterButton').attr("data-state", "closed");
      mobileFilterHidden();
      mobileSortDisplay();
    } else {
      $(this).attr("data-state", "closed");
      mobileSortHidden();
    }
  });

  $(document).on("click", ".mobileFilterButton", function () {
    var state = $(this).attr("data-state");

    if (state == "closed") {
      $(this).attr("data-state", "open");
      $('.sortHeader').attr("data-state", "closed");
      mobileSortHidden();
      mobileFilterDisplay();
    } else {
      $(this).attr("data-state", "closed");
      mobileFilterHidden();
    }
  });

  $(document).on("click", ".continueShopping", function () {
    event.preventDefault();
    hideCartNotification()
  });

  

  $(document).mouseup(function (e) {
    var container = $(".cartNotifications");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      // if the target of the click isn't the container nor a descendant of the container
      hideCartNotification();
    }
  });

  $(document).on("click", ".sliderControlButton", function () {
    event.preventDefault();
    var direction = $(this).attr("data-control");
    if (direction == "left") {
      $(".slick-prev").click();
    } else {
      $(".slick-next").click();
    }
  });

  // Replace your current js_addtocart click handler with this simplified version
  // $(document).on("click", ".js_addtocart", function(e) {
  //   e.preventDefault();
  //   console.log("Add to cart clicked");
    
  //   // Get the variant ID
  //   var variantId = parseInt($(this).attr('data-id'));
  //   console.log("Variant ID:", variantId);
    
  //   // Update button text
  //   var thisButton = $(this);
  //   var prevText = thisButton.text();
  //   thisButton.text("Added!");
    
  //   // Try direct DOM manipulation to show the notification
  //   console.log("Attempting to show cart notification");
  //   var notification = $(".cartNotifications");
  //   console.log("Cart notification exists:", notification.length > 0);
    
  //   // Force display with !important and inline styles
  //   notification.attr("style", "display: block !important; z-index: 9999 !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important;");
    
  //   // Add animation class
  //   notification.addClass("slide-in-top");
    
  //   // Log the current state
  //   console.log("Notification style:", notification.attr("style"));
  //   console.log("Notification classes:", notification.attr("class"));
    
  //   // Check if notification is visible according to jQuery
  //   console.log("Is notification visible:", notification.is(":visible"));
    
  //   // Try to update cart count
  //   $.getJSON("/cart.js", function(cart) {
  //     console.log("Cart data received");
  //     $(".cartNotificationCount").text(cart.item_count);
  //     console.log("Cart count updated to:", cart.item_count);
      
  //     if (cart.items && cart.items.length > 0) {
  //       var item = cart.items[0];
  //       $(".cartNotificationTitle").text(item.title || "Item added");
  //       if (item.image) {
  //         $(".cartNotificationImage").attr("src", item.image);
  //       }
  //       console.log("Notification content updated");
  //     }
  //   });
    
  //   // Restore button text after delay
  //   setTimeout(function() {
  //     thisButton.text(prevText);
  //   }, 1500);
    
  //   // Try to add to cart
  //   $.post('/cart/add.js', { id: variantId, quantity: 1 })
  //     .done(function(data) {
  //       console.log("Item added to cart successfully");
  //     })
  //     .fail(function(xhr) {
  //       console.log("Add to cart error:", xhr.responseText);
  //     });
  // });

  //CD Sanket
  $(document).on("click", ".js_addtocart", function (e) {
  e.preventDefault();
    var selectedProducts = [];

    // Collect selected products
  var productId = parseInt($(this).attr('data-id'));
   if ($('.product .meta-product input[type=checkbox]:checked').length) {
    selectedProducts.push({
        'id': parseInt($('.productForm input[name="id"]').val()),
        'quantity': 1
    });
     $('.meta-product input[type=checkbox]:checked').each(function () {
        productId = parseInt($(this).val());

        if (!isNaN(productId)) {
            selectedProducts.push({
                'id': productId,
                'quantity': 1
            });
        }
    });
}else{
     selectedProducts.push({
                'id': productId,
                'quantity': 1
            });
}

    
  
    let formData = {
     'items': selectedProducts
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    var prevText = $(this).text();
    $(this).text("Processing...");
    setTimeout(() => {
      $(this).text("Added!");
      showCartNotification();
      setTimeout(() => {
        $(this).text(prevText);
      }, 1500);
    }, 800);
  });
  
  // $(document).on("click", "[data-cart-add]", function () {
  //   var prevText = $(this).text();
  //   $(this).text("Processing...");
  //   setTimeout(() => {
  //     $(this).text("Added!");
  //     showCartNotification();
  //     setTimeout(() => {
  //       $(this).text(prevText);
  //     }, 1500);
  //   }, 800);
  // });

  $(document).on("click", ".faqItem", function () {
    var state = $(this).attr("data-state");
    if (state == "closed") {
      $(this).find(".faqContent").removeClass("hidden");
      $(this).find(".faqContent").addClass("fade-in");

      $(this).find("svg").addClass("fa-chevron-down");
      $(this).find("svg").removeClass("fa-chevron-right");

      $(this).attr("data-state", "open");
    } else {
      $(this).find(".faqContent").addClass("hidden");
      $(this).find(".faqContent").removeClass("fade-in");

      $(this).find("svg").removeClass("fa-chevron-down");
      $(this).find("svg").addClass("fa-chevron-right");
      $(this).attr("data-state", "closed");
    }
  });

  $(document).on("click", ".toggleContent", function () {
    event.preventDefault();
    var state = $(this).attr("data-state");

    if (state == "closed") {
      $(this).find(".underline").text("Show less");
      $(this).parents(".contentBlock").find(".fullContent").removeClass("h-16");
      $(this).find(".toggleIcon").removeClass("fa-chevron-down");
      $(this).find(".toggleIcon").addClass("fa-chevron-up");
      $(this).attr("data-state", "open");
    } else {
      $(this).find(".underline").text("Show move");
      $(this).parents(".contentBlock").find(".fullContent").addClass("h-16");
      $(this).find(".toggleIcon").addClass("fa-chevron-down");
      $(this).find(".toggleIcon").removeClass("fa-chevron-up");
      $(this).attr("data-state", "closed");
    }
  });

  $(document).on("click", ".showMore", function () {
    event.preventDefault();
    var state = $(this).attr("data-state");

    if (state == "closed") {

      $('.additionalText').css('height','auto')
      $(this).find(".underline").text("Show more");
      $(this)
        .parents(".collection_content")
        .find(".additionalText")
        .removeClass("h-72");
      $(this).find(".toggleIcon").removeClass("fa-chevron-down");
      $(this).find(".toggleIcon").addClass("fa-chevron-up");
      $(this).attr("data-state", "open");
      $(".moreContentGradient").hide();
      $('span', this).text('Show less');
    } else {
      $(this).find(".underline").text("Show less");
      $(this)
        .parents(".collection_content")
        .find(".additionalText")
        .addClass("h-72");
      $(this).find(".toggleIcon").addClass("fa-chevron-down");
      $(this).find(".toggleIcon").removeClass("fa-chevron-up");
      $(this).attr("data-state", "closed");
      $(".moreContentGradient").show();
      $('.additionalText').css('height','25em')
      $('span', this).text('Show more');
    }
  });

  $(document).on("click", ".mobileNavTrigger", function () {
    event.preventDefault();
    var state = $(this).attr("data-state");
    if (state == "closed") {
      $(this).find(".fa-xmark").removeClass("hidden");
      $(this).find(".fa-bars").addClass("hidden");
      $(".mobileNavigationMenu").addClass("ActiveDropdown");
      $(this).attr("data-state", "open");
    } else {
      $(this).find(".fa-xmark").addClass("hidden");
      $(this).find(".fa-bars").removeClass("hidden");
      $(".mobileNavigationMenu").removeClass("ActiveDropdown");
      $(this).attr("data-state", "closed");
    }
  });

  $(document).on("click", ".mobileMegaMenuTrigger", function () {
    event.preventDefault();
    var state = $(this).attr("data-state");
    if (state == "closed") {
     // $(this).find(".fa-chevron-up").removeClass("hidden");
    //  $(this).find(".fa-chevron-down").addClass("hidden");
      $(".mobileInnerMenu").addClass("ActiveDropdown");
      $(this).attr("data-state", "open");
    } else {
    //  $(this).find(".fa-chevron-down").removeClass("hidden");
   //   $(this).find(".fa-chevron-up").addClass("hidden");
      $(".mobileInnerMenu").removeClass("ActiveDropdown");
      $(this).attr("data-state", "closed");
    }
  });

  // Variant switch via collection swatches
  $(document).on("click", ".collectionSwatches", function () {
    event.preventDefault();
    var selectedVariant = $(this).attr("data-variant");
    var compare_at_price = $(this).data("compare_at_price");
    var price = $(this).data("price");
    var available = $(this).attr("data-available");
    var mainElm = $(this).parents(".productForm");
    $(this).siblings().removeClass("SelectedObject");
    $(this).addClass("SelectedObject"); // shows that option was selected
    mainElm.find(".productVariantInput").attr("value", selectedVariant); // Sets variant via input
    mainElm.find(".atc-button").attr("data-cart-add", selectedVariant); // Sets CartJS

    // available button

    if (available == "true") {
      mainElm
        .find(".atc-button")
        .addClass("inStock")
        .removeClass("outStock disabled cursor-not-allowed");
    } else if (available == "preOrder") {
      mainElm
        .find(".atc-button")
        .addClass("preOrder")
        .removeClass("outStock disabled cursor-not-allowed");
    } else {
      mainElm
        .find(".atc-button")
        .addClass("outStock disabled cursor-not-allowed")
        .removeClass("preOrder inStock");
    }
    price = price / 100;
    compare_at_price = compare_at_price / 100;
    // Update visible prices
    mainElm.find(".currentPrice").text("Now " + formatCurrency(price) + " GBP");
    if (compare_at_price > 0) {
      mainElm.find(".wasPrice").show();
      mainElm
        .find(".wasPrice")
        .text("Was " + formatCurrency(compare_at_price) + " GBP");
    } else {
      mainElm.find(".wasPrice").hide();
    }
  });

  $(document).on("click", ".productThumbs", function () {
    event.preventDefault();
    $(this).siblings().removeClass("SelectedObject");
    $(this).addClass("SelectedObject");
    var image = $(this).find(".productMainThumb").attr("src");
    $(this)
      .parents(".productMainImages")
      .find(".productMainImage")
      .attr("src", image);
  });

  $(".productCard").hover(
    function () {
      $(this).find(".productCardImageOne").addClass("hidden");
      $(this).find(".productCardImageTwo").removeClass("hidden");
    },
    function () {
      $(this).find(".productCardImageTwo").addClass("hidden");
      $(this).find(".productCardImageOne").removeClass("hidden");
    }
  );

  $(".megaMenuTrigger, .megaMenu").hover(
    function () {
      $(".megaMenu").addClass("ActiveDropdown ");
      $('.megaMenuTrigger').addClass('active');
      // $(this).find(".mmicon").removeClass("fa-chevron-down");
      // $(this).find(".mmicon").addClass("fa-chevron-up");
    },
    function () {
      $(".megaMenu").removeClass("ActiveDropdown ");
      $('.megaMenuTrigger').removeClass('active');
      // $(this).find(".mmicon").addClass("fa-chevron-down");
      // $(this).find(".mmicon").removeClass("fa-chevron-up");
    }
  );

  /*
  $(document).on("click", _$.toggleTrigger, function (event) {
    event.preventDefault();
    
    var contentBlock = $(this).parent();
    var state = contentBlock.attr("data-state");
    console.log(contentBlock)
    if (state == "closed") {
      $(this).find(".toggleIcon").removeClass("fa-chevron-down");
      $(this).find(".toggleIcon").addClass("fa-chevron-up");
      contentBlock.find(".smallExcerpt").hide();
      contentBlock.find(".fullContent").show();
    } else {
      $(this).find(".toggleIcon").addClass("fa-chevron-down");
      $(this).find(".toggleIcon").removeClass("fa-chevron-up");
      contentBlock.find(".smallExcerpt").show();
      contentBlock.find(".fullContent").hide();
    }
  });
  */
  //  Match Height
  $('.prodCard h3 a').matchHeight();
  $('.prodCard .card-price-container').matchHeight();
  $('.prodCard .reviews').matchHeight();
  $('.prodCard .priceBlock').matchHeight();
  $('.prodCard .color-swatch-container').matchHeight();
  $('.f-title').matchHeight();
  $('.usp-products .img-container').matchHeight();
  $('.usp-products p').matchHeight();
  // Product images
  $('.pimage-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.pimage-for',
    prevArrow:'<button class="sliderControlButton z-50" data-control="left"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_101_2300)"><path d="M16.97 3.56729e-06L19.8 2.83L5.65999 16.97L19.8 31.11L16.97 33.94L-9.96053e-06 16.97L16.97 3.56729e-06Z" fill="white"/><path d="M16.97 1.41003L18.39 2.83003L4.24002 16.97L18.39 31.11L16.97 32.53L1.42002 16.97L16.97 1.41003Z" fill="black"/></g><defs><clipPath id="clip0_101_2300"><rect width="19.8" height="33.94" fill="white" transform="translate(19.8 33.94) rotate(-180)"/></clipPath></defs></svg></button>',
    nextArrow:'<button class="sliderControlButton z-50" data-control="right"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_101_798)"><path d="M2.82994 33.9401L-6.10352e-05 31.1101L14.1399 16.9701L-6.10352e-05 2.83006L2.82994 5.88894e-05L19.7999 16.9701L2.82994 33.9401Z" fill="white"/><path d="M2.82994 32.5301L1.40994 31.1101L15.5599 16.9701L1.40994 2.83006L2.82994 1.41006L18.3799 16.9701L2.82994 32.5301Z" fill="black"/></g><defs><clipPath id="clip0_101_798"><rect width="19.8" height="33.94" fill="white"/></clipPath></defs></svg></button>'
  });
  $('.pimage-for').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.pimage-slider',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });

  // Cart hide
  $('#continue-basket').click(function(e){
    e.preventDefault();
    $('.cartNotifications').hide();
  });

  // Trust bar slider
  $('.icon-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: false
  });
  
  // After document is ready, try to force show cart notification for a split second to diagnose any issues
  setTimeout(function() {
    console.log("DIAGNOSTIC: Checking cart notification element on page load");
    var notification = $(".cartNotifications");
    console.log("Cart notification exists on page:", notification.length > 0);
    if (notification.length > 0) {
      console.log("Initial display:", notification.css("display"));
      console.log("Initial visibility:", notification.css("visibility"));
      console.log("Initial opacity:", notification.css("opacity"));
      console.log("Initial z-index:", notification.css("z-index"));
      console.log("Initial position:", notification.css("position"));
    }
  }, 1000);
});

function buyNow(variantId) {
  // Add item to cart
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',
    success: function() {
      // Redirect to checkout
      window.location.href = '/checkout';
    },
    error: function(xhr) {
      console.log("Error adding to cart:", xhr.responseText);
      alert("Sorry, there was an error. Please try again.");
    }
  });
}




